const guiColors = {
    'motion-primary': 'hsla(198, 60%, 60%, 1)',
    'motion-primary-transparent': 'hsla(198, 60%, 60%, 0.9)',
    'motion-tertiary': 'hsla(198, 60%, 45%, 1)',

    'looks-secondary': 'hsla(198, 60%, 60%, 1)',
    'looks-transparent': 'hsla(198, 60%, 60%, 0.35)',
    'looks-light-transparent': 'hsla(198, 60%, 60%, 0.15)',
    'looks-secondary-dark': 'hsla(198, 60%, 45%, 1)',

    'extensions-primary': 'hsla(208, 51%, 60%, 1)',
    'extensions-tertiary': 'hsla(208, 51%, 35%, 1)',
    'extensions-transparent': 'hsla(208, 51%, 60%, 0.35)',
    'extensions-light': 'hsla(208, 34%, 80%, 1)',

    'drop-highlight': 'hsl(198, 60%, 73%)'
};

const blockColors = {
    checkboxActiveBackground: 'hsl(198, 60%, 60%)',
    checkboxActiveBorder: 'hsl(198, 60%, 45%)'
};

export {
    guiColors,
    blockColors
};